export enum DocumentationEnum {
  DOC_URL_ACTIONS = 'DOC_URL_ACTIONS',
  DOC_URL_MONITORING = 'DOC_URL_MONITORING',
  DOC_URL_VIRTUAL_LOBBY = 'DOC_URL_VIRTUAL_LOBBY'
}
